<section class="our-services">
  <h2 class="gs1-h2 font-500">{{ 'home.our-services.title' | translate }}</h2>

  <div class="cards-list">
    @for (card of cardsList; track $index) {
      <gs1-card [name]="card.name" [clickable]="true" type="default" (click)="navigateTo(card.url, card.route, card.name)">
        <img [src]="card.image" [alt]="card.title" width="63" height="63" />
        <h3 class="gs1-card-title">{{ card.title }}</h3>
        <p class="gs1-card-text gs1-little">{{ card.text }}</p>
      </gs1-card>
    }
  </div>
</section>
